import { Model } from '@vuex-orm/core';


export default class Diode extends Model {
  static entity = 'diodes'
  static primaryKey = 'serial'

  static fields() {

    return {
      serial: this.string(''),
      name: this.string(''),
      location: this.string(''),
      user: this.attr(null).nullable(),
      heartbeat: this.string(null).nullable()
    };
  }
}
